
<template>
  <v-card fluid>
  <v-card-title class="blue darken-3">
          <span class="text-h5 white--text">ETC Intrared Spectrum(SPIP)</span>
  </v-card-title>

<v-banner></v-banner>

  <v-data-table
    :headers="columns"
    :items="alldata"
    class="elevation-1"
  >
      <template v-slot:top>
      <v-toolbar
        flat
      >
        <v-toolbar-title></v-toolbar-title>

        <v-divider
          class="mx-4"
          inset
          vertical
        ></v-divider>

        <v-spacer></v-spacer>

        <v-dialog
          v-model="dialog_target"
         >
          <v-card >
         <v-card-title>{{title_feunetre}}
         </v-card-title>

            <v-card-text>

              <v-row
                class="pa-0"
              >
                <v-col
                  cols="30"
                  md="4"
                >
                  <v-text-field
                    v-model= "editedItem.objet"
                    :counter="20"
                    label="name"
                    required
                  ></v-text-field>

                </v-col>
                <v-col>



                  <v-btn
                    color="primary"
                    class="ma-2"
                    dark
                    @click='Simbad()'
                  >Simbad
                  </v-btn>

                </v-col>
              </v-row>

              <br>

              <v-divider></v-divider>

              <br>

              <v-row>
                <v-col
                  cols="7"
                  md="2"
                >
          
                <v-text-field
                    v-model= "editedItem.magv"
                    type= "number"
                    label= "Mag.V"
                    required
                  ></v-text-field>

                </v-col>
                <v-col
                  cols="7"
                  md="2"
                >

                  <v-text-field
                    v-model= "editedItem.magb"
                    type= "number"
                    label= "Mag.B"
                    required
                  ></v-text-field>

                </v-col>
                <v-col
                  cols="12"
                  md="2"
                >

                  <v-text-field
                    v-model= "editedItem.magh"
                    type="number"
                    label="Mag.H"
                    required
                  ></v-text-field>

                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  md="2"
                >
                  <v-text-field
                    v-model = "editedItem.spectype"
                    label= "Spec. Typ"
                    required
                  ></v-text-field>

                </v-col>
              <v-col
                  cols="12"
                  md="2"
                >
                </v-col>                
              </v-row>

              <v-row>
                <v-col
                  cols="7"
                  md="2"
                >
                  <v-text-field
                    v-model= "editedItem.alpha"
                    label="Alpha"
                    required
                  >
                  </v-text-field>

                </v-col>
                <v-col
                  cols="7"
                  md="2"
                >

                  <v-text-field
                    v-model= "editedItem.delta"
                    label="Delta"
                    required
                  >
                  </v-text-field>

                </v-col>
                <v-col
                  cols="7"
                  md="2"
                >

                  <v-text-field
                    v-model= "editedItem.equ"
                    label="Epoch"
                    required
                  >
                  </v-text-field>

                  <v-checkbox
                    v-model= "editedItem.ephemeris"
                    hide-details
                    label= "Ephemeris"
                  ></v-checkbox>

                </v-col>
              </v-row>

            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                class="ma-2"
                dark
                @click="saveItem()"
                >Save
              </v-btn>
              
              <v-btn
                color="primary"
                class="ma-2"
                dark
                @click="close()"
                >Cancel
              </v-btn>

            </v-card-actions>
          </v-card>

      </v-dialog>


        <v-dialog
          v-model="dialog"
          max-width="500px"
          :retain-focus="false"
        >
          <template  v-slot:activator="{}">

 
            <v-icon
              color="blue darken-3"
              class="ma-2"
              @click="addItem()"
            >mdi-plus-circle     
            </v-icon>

          </template>
        </v-dialog>
      </v-toolbar>
      </template>

      <template v-slot:[`item.actions`]="{ item }">

        <v-icon 
          small
          class="ma-2"
          @click="editItem(item)"
          >mdi-pencil
        </v-icon>

        <v-icon
          small
          class="ma-2"
          @click="deleteItem(item)"
          >mdi-delete
        </v-icon>


        <v-dialog
          v-model="dialog_delete"
          max-width="1000px"
          style="z-index: 1000"
          :retain-focus="false"
        >
          <v-card flat>
            
            <v-card-title>
              
              <span class="headline" >Do you really want to remove the Target  ?
              </span>

            </v-card-title>
            <v-card-actions>

              <v-spacer></v-spacer>

              <v-btn 
                color="primary"
                class="ma-2"
                dark
                @click="close()"
                >Cancel
              </v-btn>

              <v-btn
                color="primary"
                class="ma-2"
                dark
                @click="deleteThisItem()"
                >Yes
              </v-btn>
                            
            </v-card-actions>
            
          </v-card>
        </v-dialog>



      
    </template>

    <template>


    </template>

  </v-data-table>

</v-card>
</template>
<script>
  
  export default {
    data: () =>({

      title_feunetre : "",

      dialog: false,
            
      dialog_target: false,
      dialog_delete: false,
      dialog_test: false,

      Id: -1,
      itemDialog: false,
      itemDeleteDialog: false,
            
      url: "http://wwwtbl4.bagn.obs-mip.fr:8080/Target",
      
      title: "Target",
      name: "target",
      alldata : [],
      writable: { type: Boolean, default: true },

      search: "",

      editedItemIndex: -1,
      editedItem: {},
      defaultItem: {
            spectype :"-",
            objet : "earth",
            alpha : "hh mm ss.ss",
            delta : "+dd mm ss.ss",
            magv : 0,
            magb : 0,
            magh : 0,
            nscode : "TBL_2023A_001",
            equ : 2049,
            ephemeris: false
      },

      tabledata: [],
      uniquesourcevalues: [],
      error: false,

      columns:[
        {
          "text": "Name",
          "value": "objet",
        },
        {
          "text": "Alpha",
          "value": "alpha",
        },
        {
          "text": "Delta",
          "value": "delta",
        },
        {
          "text": "Mag B",
          "value": "magb",
        },
        {
          "text": "Mag V",
          "value": "magv",
        },
        {
          "text": "Mag H",
          "value": "magh",
        },
        {
          "text": "Actions",
          "value": "actions",
        },
        
      ],
      epoch: ['2015','2005','2000','1950'],


    }),
    initialize(){
      //this.Fill_tab();
    },
  created(){
    this.Fill_Tab();
  },
  beforeMount(){

  },
  mounted(){
    this.Fill_Tab();
  },

  methods: {



  Save(){
 
    this.Fill_Tab();
 

  },

  Fill_Tab(){
    this.axios.get(this.url)
      .then((res) => {

        this.alldata = res.data;
      })
      .catch(() => {
        //alert("ca merde");
         // this.error = true;
      });
      //alert("init");
      //this.show();

    },

  saveItem() {

      if (this.editedItemIndex > -1) {
        this.axios
          .put(this.url + "/update/" + this.Id, this.editedItem)
          .then(() => {
            this.axios.get(this.url).then((res) => (this.alldata = res.data));
          })
          .then(() => this.close());
      } else {
        this.axios
          .post(this.url + "/creat", this.editedItem)
          .then(() => {
            this.axios.get(this.url).then((res) => (this.alldata = res.data));
          })
          .then(() => this.close());
      }
      this.close();
    },

    editItem(item) {
      this.title_feunetre = "Editing a Target";
      this.editedItemIndex = this.alldata.indexOf(item);
      this.Id = this.alldata[this.editedItemIndex].id;
      this.editedItem = Object.assign({}, item);
      this.dialog_target = true;
    },
    addItem() {
      this.title_feunetre = "New Target";
      this.editedItem = this.defaultItem;
      this.editedItemIndex = -1;
      this.dialog_target = true;
    },

    deleteItem(item) { 

      this.dialog_delete = true;
      this.IthemId = item;
      this.editedItemIndex = this.alldata.indexOf(item);
    },
    deleteThisItem() {
        console.log(this.url);
        this.axios
        .delete(this.url + "/delete/" + this.alldata[this.editedItemIndex].id)
        .then(() => {
          this.axios.get(this.url).then((res) => (this.alldata = res.data));
        })
        .then(() => this.close());
    },
    close() {
      this.dialog_target = false;    
      this.dialog_delete = false;
      Object.assign(this.editedItem,this.defaultItem);
      this.editedItemIndex = -1;
      this.Id = -1;
    },
      Simbad(){
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    var result,results;
    var objet = this.editedItem.objet;
    var obj = new Object();

    obj.realname = objet;

//    try{
//           objet = objet.replace(/\+/g,"%2B");
//           objet = objet.replace(/\*/g,"%2A");
//           objet = objet.replace(/ /g,"%20");
           //http://simbad.u-strasbg.fr/simbad/sim-basic?Ident=rigel&submit=SIMBAD
        //request = "http://simweb.u-strasbg.fr/simbad/sim-script?script=format%20object%20%22%25IDLIST%281%29%20%7c%20%25COO%28A%20D%29%7c%20%25FLUXLIST%28B%3bF%29%7c%20%25FLUXLIST%28V%3bF%29%7c%20%25SP%22%0a";
        //request = "http://simweb.u-strasbg.fr/simbad/sim-script?script=format%20object%20%22%25IDLIST%281%29%20%7c%20%25COO%28A%20D%29%7c%20%25FLUXLIST%28B%3bF%29%7c%20%25FLUXLIST%28V%3bF%29%7c%20%25FLUXLIST%28H%3bF%29%7c%20%25SP%22%0a";
//https://simbad.u-strasbg.fr/simbad/sim-script?script=format%20object%20%22%25IDLIST%281%29%20%7c%20%25COO%28A%20D%29%7c%20%25FLUXLIST%28B%3bF%29%7c%20%25FLUXLIST%28V%3bF%29%7c%20%25FLUXLIST%28H%3bF%29%7c%20%25SP%22%0arigel
        axios.get(`http://simweb.u-strasbg.fr/simbad/sim-script?script=format%20object%20%22%25IDLIST%281%29%20%7c%20%25COO%28A%20D%29%7c%20%25FLUXLIST%28B%3bF%29%7c%20%25FLUXLIST%28V%3bF%29%7c%20%25FLUXLIST%28H%3bF%29%7c%20%25SP%22%0a` + objet)
         .then(res => {
          var trouve = false;
          var flag_header = false;
          var columns_detail = false;
          var c_alpha = 0;
          var c_delta = 0;
          var c_magv = 0;
          var c_magb = 0;
          var c_magh = 0;
          var count = 0;
          var t_obj = [];

          console.log(res);
          var results = res.data.split("\n");
          console.log(results);

          for(var l in results){if(!trouve){
            console.log(l + " - " + results[l] );

            if(results[l]=="::error:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::")console.log("Erreur!!!");
                 if(results[l].indexOf('::error::',0) != -1){
                    obj={"objet":objet,"alpha":"9999","delta":"9999","magb":"9999","magv":"9999","magh":"9999","message":"Err","spectype":"Unregistered Star (2)","equ":"2000"};
                }

                if(results[l].indexOf('::data::',0) != -1){


                    t_obj = results[l*1+2].split("|");

                    t_obj[0] = t_obj[0].replace(/ /g,'' );
                    t_obj[0] = t_obj[0].replace(/\*/g,'' );

                    obj.objet = objet;
                    //console.log(obj);
                    if(t_obj[1].indexOf(' +',0) != -1){
                        obj.alpha = t_obj[1].split(" +")[0];
                        obj.alpha = obj.alpha.substring(1,obj.alpha.length);
                        obj.delta = "+" + t_obj[1].split(" +")[1];

                    }else{
                        obj.alpha = t_obj[1].split(" -")[0];
                        obj.alpha = obj.alpha.substring(1,obj.alpha.length);
                        obj.delta = "-" + t_obj[1].split(" -")[1];
                    }

                    // Mag V
                    t_obj[3] = t_obj[3].replace(/ /g,'' );
                    obj.magv = t_obj[3];

                    // Mag B
                    t_obj[2] = t_obj[2].replace(/ /g,'' );
                    obj.magb = t_obj[2];

                    // Mag H
                    t_obj[4] = t_obj[4].replace(/ /g,'' );
                    obj.magh = t_obj[4];

                    //console.log(obj);
                    obj.spectype = t_obj[5].split(" ")[1];
                    obj.equ = "2000";
                    //console.log(obj);
                }

               

                this.editedItem.objet     = obj.objet;
                this.editedItem.alpha     = obj.alpha;

                this.editedItem.delta     = obj.delta;
                this.editedItem.magv      = obj.magv;
                this.editedItem.magb      = obj.magb;
                this.editedItem.magh      = obj.magh;
                this.editedItem.spectype  = obj.spectype;
                this.editedItem.equ       = obj.equ       = "2000";



/*            if(columns_detail)if(!flag_header){
                console.log("collum detail");
                if(results[l].indexOf('RA',0) != -1)if(results[l].indexOf('ICRS',0) != -1){c_alpha=count;console.log("c_alpha "+ c_alpha);}
                if(results[l].indexOf('DE',0) != -1)if(results[l].indexOf('ICRS',0) != -1){c_delta=count;console.log("c_delta "+ c_delta);}
                if(results[l].indexOf('VTmag',0) != -1){c_magv=count;console.log("c_magv "+ c_magv);}
                if(results[l].indexOf('BTmag',0) != -1){c_magb=count;console.log("c_magb "+ c_magb);}
                count++;
            }
            if(columns_detail)if(!flag_header)if(results[l].indexOf('----',0) != -1){
                columns_detail = false;
                //console.log("on est plus dans le detail des collumn");
            }
            if(results[l].indexOf('#---Details of Columns',0) != -1){
                columns_detail = true;
                //console.log("trouve ...");
            }                
           //console.log(results[l]);       
            if(results[l].indexOf('TYC1 TYC2',0) != -1){
                flag_header = true;
                //console.log("trouve ...");
            }
            if(flag_header)if(results[l].indexOf('TYC1 TYC2',0) == -1)if(results[l].indexOf('----',0) == -1)if(!trouve){
                //console.log("--> " + results[l]);
                var analyse;
                analyse = results[l].replace(/\t/g," ");
                analyse = analyse.replace(/       /g," HIP ");
                analyse = analyse.replace(/  /g," ");
                analyse = analyse.replace(/  /g," ");
                analyse = analyse.replace(/  /g," ");
                analyse = analyse.split(" ");
                //console.log(analyse);

                var offset    = 0;if(analyse[0] == ''){offset = 1;}

                this.editedItem.objet     = obj.objet     = objet.replace(/%20/g,"");;
                this.editedItem.alpha     = obj.alpha     = t_alpha_hms(analyse[c_alpha+offset]);

                this.editedItem.delta     = obj.delta     = t_delta_hms(analyse[c_delta+offset]);
                this.editedItem.magv      = obj.magv      = analyse[c_magv+offset];
                this.editedItem.magb      = obj.magb      = analyse[c_magb+offset];
                this.editedItem.spectype  = obj.spectype  = "-";
                this.editedItem.equ       = obj.equ       = "2000";

                trouve = true;
                //console.log("Vizier ..........................................................................................");
                //console.log(obj);
            }*/
          }}
        })
        .catch(err => {
          console.warn(err);

        }) 
      },

      Vizier(){
        var obj = new Object();
        var objet = this.editedItem.objet;
        obj.realname = objet;
        //axios.get('http://127.0.0.1:8080/Vizier',{ params: { objet: this.i_name } })
        axios.get(`https://vizier.u-strasbg.fr/viz-bin/asu-txt?-source=+Tycho-2&-c=` + objet)
         .then(res => {

          var trouve = false;
          var flag_header = false;
          var columns_detail = false;
          var c_alpha = 0;
          var c_delta = 0;
          var c_magv = 0;
          var c_magb = 0;
          var c_magh = 0;
          var count = 0;
          var results = res.data.split("\n");

          for(var l in results){if(!trouve){
 

            if(columns_detail)if(!flag_header){
                console.log("collum detail");
                if(results[l].indexOf('RA',0) != -1)if(results[l].indexOf('ICRS',0) != -1){c_alpha=count;console.log("c_alpha "+ c_alpha);}
                if(results[l].indexOf('DE',0) != -1)if(results[l].indexOf('ICRS',0) != -1){c_delta=count;console.log("c_delta "+ c_delta);}
                if(results[l].indexOf('VTmag',0) != -1){c_magv=count;console.log("c_magv "+ c_magv);}
                if(results[l].indexOf('BTmag',0) != -1){c_magb=count;console.log("c_magb "+ c_magb);}
                count++;
            }
            if(columns_detail)if(!flag_header)if(results[l].indexOf('----',0) != -1){
                columns_detail = false;
                //console.log("on est plus dans le detail des collumn");
            }
            if(results[l].indexOf('#---Details of Columns',0) != -1){
                columns_detail = true;
                //console.log("trouve ...");
            }                
           //console.log(results[l]);       
            if(results[l].indexOf('TYC1 TYC2',0) != -1){
                flag_header = true;
                //console.log("trouve ...");
            }
            if(flag_header)if(results[l].indexOf('TYC1 TYC2',0) == -1)if(results[l].indexOf('----',0) == -1)if(!trouve){
                //console.log("--> " + results[l]);
                var analyse;
                analyse = results[l].replace(/\t/g," ");
                analyse = analyse.replace(/       /g," HIP ");
                analyse = analyse.replace(/  /g," ");
                analyse = analyse.replace(/  /g," ");
                analyse = analyse.replace(/  /g," ");
                analyse = analyse.split(" ");
                //console.log(analyse);

                var offset    = 0;if(analyse[0] == ''){offset = 1;}

                this.editedItem.objet     = obj.objet     = objet.replace(/%20/g,"");;
                this.editedItem.alpha     = obj.alpha     = t_alpha_hms(analyse[c_alpha+offset]);

                this.editedItem.delta     = obj.delta     = t_delta_hms(analyse[c_delta+offset]);
                this.editedItem.magv      = obj.magv      = analyse[c_magv+offset];
                this.editedItem.magb      = obj.magb      = analyse[c_magb+offset];
                this.editedItem.magh      = obj.magh      = analyse[c_magb+offset];
                this.editedItem.spectype  = obj.spectype  = "-";
                this.editedItem.equ       = obj.equ       = "2000";

                

                trouve = true;
                //console.log("Vizier ..........................................................................................");
                //console.log(obj);
            }
          }}
        })
        .catch(err => {
          console.warn(err);
          obj={"alpha":"9999","delta":"9999","magb":"9999","magv":"9999","magh":"9999","spectype":"Err","objet":"Unregistered Star (2)","equ":"2000"};


        }) 
      },
 
  }
}

</script>